import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import { useRouter } from 'next/router';
import { i18n as I18n } from 'utils/i18n';
import { getVenueImage } from 'utils/venueImages';

const FavouriteVenue = ({ venue, onRemove }) => {
  const router = useRouter();

  const onBookNow = () => {
    router.push(`/properties/${venue.id}#venue-rooms-section`);
  };

  const renderImage = () => {
    if (getVenueImage(venue)) {
      return <img src={getVenueImage(venue)} alt={venue.name} />;
    }
    return (
      <div className="venue__image">
        <div>
          {I18n.t('shared.image')}
          <br />
          {I18n.t('shared.coming_soon')}
        </div>
      </div>
    );
  };

  return (
    <li className="favourite" data-testid="favouriteVenue">
      <div className="favourite__image">{renderImage()}</div>
      <div className="favourite__inner">
        <div className="favourite__header">
          <h4 className="favourite__title">
            <Link href={`properties/${venue.id}`}>
              <a>{venue.name}</a>
            </Link>
          </h4>
          <button
            onClick={onRemove}
            className="favourite__remove"
            data-testid="removeFavouriteButton"
          >
            <ReactSVG src="/images/icons/accounts/remove.svg" />
          </button>
        </div>

        <div className="favourite__details">
          <Link href={`properties/${venue.id}`}>
            <a>{I18n.t('favourite.view_property_details')}</a>
          </Link>
          <button
            onClick={onBookNow}
            className="button button--primary button--small"
            data-testid="onBookNow"
          >
            {I18n.t('shared.book_now')}
          </button>
        </div>
      </div>
    </li>
  );
};

FavouriteVenue.propTypes = {
  venue: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default FavouriteVenue;
